import styled from "styled-components";
import { mobileAuthSideContainer, mobileAuthMainContainer } from "../../styles/authShellMixins";


export const MainContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--accent, #6b8f71);
    border-radius: 10px;
  }

  ${mobileAuthMainContainer}
`;

export const SideContainer = styled.div`
  scrollbar-width: none; 
  overflow-y: auto; 
  overflow-x: hidden; 
  position: relative; 
  height: 100vh; 
  min-height: 100vh; 
  width: ${({ collapsed }) => (collapsed ? "calc(100% - 6vw)" : "calc(100% - 15vw)")
  };
  margin: auto;
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    display: none;
  }

  ${mobileAuthSideContainer}
`;

// Wrapper do conteúdo
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  flex: 0 0 auto;
  height: auto;
  min-height: min-content;
  max-width: none;
  padding: 1.25rem 1.25rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  box-sizing: border-box;
  overflow: visible;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 1rem 0;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  text-align: center;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin: 0 0 0.75rem 0;
  }
`;

export const HeaderSection = styled.header`
  text-align: center;
  position: relative;
  width: 100%;
  flex-shrink: 0;
`;

export const TabsRow = styled.div`
  display: flex;
  gap: 0.8rem;
  margin: 0 0 1rem 0;
  width: 100%;
  flex-shrink: 0;
`;

export const TabButton = styled.button`
  background: ${({ active }) => active ? "var(--accent-soft)" : "var(--surface-glass)"
  };
  border: 2px solid
    ${({ active }) => (active ? "var(--accent)" : "var(--border-default)")
  };
  color: ${({ active }) => (active ? "var(--accent-secondary)" : "var(--text-primary)")
  };
  border-radius: 12px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--accent);
    transform: translateY(-1px);
  }
`;

export const FormContainer = styled.form`
  gap: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.5rem;
  border-radius: 20px;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  width: 50vw;
  margin: auto;

  position: relative;
  overflow: hidden;
  min-height: 8vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, var(--accent-secondary-soft) 0%, var(--accent-soft) 100%);
    opacity: 0.3;
    z-index: -1;
    border-radius: 18px;
  }

  @media screen and (max-width: 768px) {
    width: 90vw;
    padding: 1.5rem;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  width: 100%;
  position: relative; 
  z-index: 2;
  margin: 0 0 1rem 0;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
    gap: 0.75rem;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  min-width: 4vw;
  position: relative;
  z-index: 2;
  margin: auto;
`;

export const RightColumn = styled.div`
  flex: 2;
  min-width: 4vw;
  position: relative;
  z-index: 2;
  margin: auto;
`;

export const Label = styled.label`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0.5rem;
  display: block;
  position: relative;
  z-index: 2;
`;

export const ShowInput = styled.input`
  width: 17vw;
  height: 3vw;
  padding: 0.8vw 0.8vw;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledSelect = styled.select`
  width: 17vw;
  height: 3vw;
  padding: 0.8vw 0.8vw;
  padding-right: 50px; // Aumenta o espaço para a seta + margem
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background-color: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  position: relative;
  z-index: 2;
  
  // Remove as propriedades de direção RTL
  text-align: left;
  direction: ltr;

  // Custom arrow (seta personalizada) na direita com margem
  appearance: none;
  background-image:
    linear-gradient(45deg, transparent 50%, var(--text-heading) 50%),
    linear-gradient(135deg, var(--text-heading) 50%, transparent 50%);
  background-repeat: no-repeat;
  background-position: calc(100% - 22px) calc(50% - 2px), calc(100% - 17px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;

  option {
    background: var(--surface-overlay);
    color: var(--text-primary);
  }

  &:focus {
    border-color: var(--accent);
    background-color: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    padding-right: 45px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  position: relative;
  z-index: 2;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledButton = styled.button`
  background: ${props => props.secondary ? 'var(--input-bg)' : 'var(--accent-secondary-soft)'
  };
  border: 2px solid ${props => props.secondary ? 'var(--border-default)' : 'var(--border-default)'
  };
  border-radius: 16px;
  color: ${props => props.secondary ? 'var(--text-primary)' : 'var(--text-heading)'
  };
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      ${props => props.secondary ? 'var(--surface-glass) 0%, var(--surface-3) 100%' : 'var(--accent-secondary-soft) 0%, var(--accent-soft) 100%'
  }
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 14px;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 14px;
    background: transparent;
    box-shadow: ${props => props.secondary ? 'var(--shadow-sm)' : 'var(--shadow-sm)'
  };
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-3px);
    border-color: ${props => props.secondary ? 'var(--text-muted)' : 'var(--accent)'
  };
    color: var(--text-primary);

    &::before {
      opacity: 1;
    }

    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;
